export default "__VITE_ASSET__d3ebd6ac__"